export default [
  'IDN',
  'GBR',
  'THA',
  'IND',
  'JPN',
  'AUS',
  'RUS',
  'FIN',
  'SWE',
  'NOR',
  'DNK',
  'USA',
  'KOR',
  'PHL',
  'KEN',
  'ETH',
  'SGP',
]



// WEBPACK FOOTER //
// ./src/data/countries.js